import { Component, OnInit } from '@angular/core';
import { CookieBannerService } from '../cookie-banner/cookie-banner.service';

@Component({
  selector: '[app-footer]',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  constructor(private cookieBannerService: CookieBannerService) {}

  ngOnInit(): void {}

  /**
   * Opent de cookie-instellingen modal door de publieke methode
   * op de CookieBannerComponent aan te roepen.
   */
  openPrivacySettings(): void {
    this.cookieBannerService.openCookieModal();
  }
}
